import { useEffect } from 'react';
const FOCUSABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'textarea:not([disabled])',
    'select:not([disabled])',
    'iframe',
    '[contenteditable]:not([contenteditable="false"])',
    'details > summary:first-of-type',
    '[tabindex]:not([tabindex="-1"])',
].join(', ');
const useFocusTrap = (containerRef) => {
    useEffect(() => {
        const container = containerRef.current;
        if (!container)
            return;
        const handleKeyDown = (event) => {
            if (event.key !== 'Tab')
                return;
            const focusableElements = container.querySelectorAll(FOCUSABLE_SELECTOR);
            if (focusableElements.length === 0) {
                event.preventDefault();
                return;
            }
            const first = focusableElements[0];
            const last = focusableElements[focusableElements.length - 1];
            if (event.shiftKey) {
                if (document.activeElement === first) {
                    event.preventDefault();
                    last.focus();
                }
            }
            else {
                if (document.activeElement === last) {
                    event.preventDefault();
                    first.focus();
                }
            }
        };
        container.addEventListener('keydown', handleKeyDown);
        return () => {
            container.removeEventListener('keydown', handleKeyDown);
        };
    }, [containerRef]);
};
export default useFocusTrap;
